"use client";

import { Clock, Heart, FileText, Search, ShoppingBag, User, LogOut } from "lucide-react"
import { usePathname } from "next/navigation";
import { signOut } from "next-auth/react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { clearOperatorSessionArtifacts } from "@/utils/logout";

const navItems = [
    { href: "/account/profilo", label: "Profilo", icon: User },
    { href: "/account/attivita", label: "Le mie attività", icon: Clock },
/*
    { href: "/account/preferiti", label: "Preferiti", icon: Heart },
*/
    { href: "/account/valutazioni", label: "Valutazioni", icon: FileText },
    { href: "/account/ricerche-salvate", label: "Ricerche salvate", icon: Search },
    { href: "/account/ordini", label: "I miei ordini", icon: ShoppingBag },
]

const Sidebar = () => {
    const pathname = usePathname();
    const handleLogout = async () => {
        try {
            await fetch("/api/auth/logout-cleanup", {
                method: "POST",
                credentials: "include",
            });
        } catch (error) {
            console.error("Logout cleanup failed", error);
        }

        clearOperatorSessionArtifacts();
        void signOut({
            callbackUrl: "/",
            redirect: true,
        }).then((r) => console.log(r));
    };
    console.log(pathname);

    return (
        <div className="w-full border-b border-gray-200 bg-white lg:h-screen lg:w-64 lg:border-b-0 lg:border-r">
            <nav className="flex gap-2 overflow-x-auto p-3 lg:block lg:space-y-2 lg:overflow-visible lg:p-4">
                {navItems.map((item) => {
                    const Icon = item.icon
                    const isActive = pathname === item.href || pathname.startsWith(`${item.href}/`)

                    return (
                        <Link
                            key={item.href}
                            href={item.href}
                            className={cn(
                                "flex shrink-0 lg:block",
                                item.href === "/account/ordini" && "order-1 lg:order-none",
                                item.href === "/account/attivita" && "order-2 lg:order-none",
                                item.href === "/account/profilo" && "order-5 lg:order-none",
                                item.href === "/account/valutazioni" && "order-3 lg:order-none",
                                item.href === "/account/ricerche-salvate" && "order-4 lg:order-none",
                            )}
                        >
                            <Button
                                variant="ghost"
                                className={cn(
                                    "h-auto min-h-10 justify-start whitespace-nowrap rounded-full px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 lg:w-full lg:justify-start lg:rounded-md",
                                    isActive && "bg-gray-100 text-gray-900",
                                )}
                            >
                                <Icon className="mr-2 h-4 w-4 lg:mr-3" />
                                {item.label}
                            </Button>
                        </Link>
                    )
                })}

                <div className="order-last shrink-0 pl-2 lg:order-none lg:border-t lg:border-gray-200 lg:pt-4 lg:pl-0">
                    <Button
                        onClick={handleLogout}
                        variant="ghost"
                        className="h-auto min-h-10 whitespace-nowrap rounded-full px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 lg:w-full lg:justify-start lg:rounded-md"
                    >
                        <LogOut className="mr-2 h-4 w-4 lg:mr-3" />
                        Logout
                    </Button>
                </div>
            </nav>
        </div>
    )
};

export default Sidebar;
